// import React from "react";

// const NewModal = ({ onClose }) => {
//   return (
//     <div className="new-modal-overlay">
//       <div className="new-modal">
//         <h1>Minha Nova Modal</h1>
//         <p>Esta modal é independente da modal principal.</p>
//         <button onClick={onClose}>Fechar</button>
//       </div>
//     </div>
//   );
// };

// export default NewModal;

import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { Input } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";
const NewModal = (props) => {
  const {
    open,
    title,
    content,
    rejeicao,
    handleClose,
    cancelButtonTitle,
    confirmButtonTitle,
    onConfirm,
    rejeicaoEst,
    onClose,
    payload
  } = props;


  const [motive, setMotive] = React.useState("");
  const [motiveError, setMotiveError] = React.useState("");


  const handleConfirmClick = () => {
        setMotiveError(false)
        onConfirm(motive , "IN_ACTIVE" , payload)
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle style={{margin:"0", lineHeight:"1.5", fontFamily: "Poppins", fontSize: "1rem", fontWeight: "400" , color: "#637381"}} >{title}</DialogTitle>
      <DialogContent>
          <FormControl fullWidth sx={{mt:3}}>
            <TextField
             sx={{
                width: "100%",
                mt: 1,
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#37B34A",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#37B34A", 
                  },
                },
                "& label.Mui-focused": {
                  color: "#37B34A", 
                },
              }}
              id="motivo"
            
              label={'Razão da Desativação'}
              multiline
              minRows={4}
              value={motive}
              onChange={(e) => {
                setMotive(e.target.value)
              }}
              
            />
            
          </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} style={{color: "#37B34A" , fontWeight: "700" , fontFamily: "Poppins" , fontSize:"13px"}}>Cancelar</Button>
        <Button onClick={handleConfirmClick} style={{color: "#37B34A" , fontWeight: "700" , fontFamily: "Poppins" , fontSize:"13px"}}>Confirmar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewModal;

NewModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.any,
  cancelButtonTitle: PropTypes.string.isRequired,
  confirmButtonTitle: PropTypes.string.isRequired,
  rejeicao: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
};
